module.exports = __webpack_public_path__ + "static/vib_play10-e24ac7069f5d3b26e94e4176b2ae3b1c.jpg";